import { render, staticRenderFns } from "./ProductFeedbackContainer.vue?vue&type=template&id=8c6a2170&"
import script from "./ProductFeedbackContainer.vue?vue&type=script&lang=js&"
export * from "./ProductFeedbackContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports